import React from 'react';

import { useState, useEffect } from 'react';


import axios from 'axios';



import LoadingButton from 'components/Shared/LoadingButton';





export default function RelancerGenerationAvoir({ actionId, reloadHistory, utilisateurCourantAdmin }) {


    const [retrying, setRetrying] = useState(false);
    const [acknowledging, setAcknowledging] = useState(false);

    // Relance
    useEffect(() => {

        const retry = () => {
            axios.post(`api/reclamationActions/${actionId}/relancer-generation-avoir`)
                .then(function (response) {
                    //console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setRetrying(false);
                    reloadHistory();
                });
        };

        if (retrying) {
            retry();
        }

    }, [actionId, retrying]);

    // Abandon
    useEffect(() => {

        const retry = () => {
            axios.post(`api/reclamationActions/${actionId}/abandonner-generation-avoir`)
                .then(function (response) {
                    //console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setAcknowledging(false);
                    reloadHistory();
                });
        };

        if (acknowledging) {
            retry();
        }

    }, [actionId, acknowledging]);


    

    return (
        <>
            <LoadingButton
                onClick={() => setRetrying(true)}
                label="Relancer"
                pending={retrying}
            />

            {utilisateurCourantAdmin && (
                <LoadingButton
                    onClick={() => setAcknowledging(true)}
                    label="Abandonner"
                    pending={acknowledging}
                />
            )}
        </>
        
    );

}


